<template>
  <div>
    <v-card flat class="justify-center" :id="`datastory-` + datastory.id">
      <v-layout row wrap align-center :reverse="reversing && !expandStory">
        <v-flex :xs12="expandStory" :sm12="!expandStory" :md6="!expandStory" :md10="expandStory" :lg8="expandStory"
                :offset-md1="expandStory" :offset-lg2="expandStory"
                :justify-end="!expandStory"
                order-xs2>
          <v-card-title class="pb-0">
            <h3 class="flex xs12 display-1" v-if="!expandStory">{{ datastory.story.title }}</h3>
            <h3 class="flex xs12 font-weight-thin font-italic">{{ formatPublicationDate(datastory.publication_date) }}</h3>
            <h2 class="flex xs12 display-2" v-if="expandStory">{{ datastory.story.title }}</h2>
          </v-card-title>
          <v-card-text class="headline" v-html="datastory.story.teaser">
          </v-card-text>
          <v-flex :offset-xs10="!reversing">
            <v-btn small flat round color="primary"
                   @click="toggleDataStory()"
                   v-if="!archived">{{ btnLabel }}</v-btn>
          </v-flex>
        </v-flex>
        <v-flex :xs12="expandStory" :sm12="!expandStory" :md6="!expandStory" order-xs1>
          <v-img height="35rem"
                        :src="require(`@/assets/img/datastories/${getTeaserImage(datastory.images)}`)"
          >
          </v-img>
        </v-flex>
        <v-flex md12 order-xs3>
          <v-slide-y-transition>
            <v-card-text v-show="expandStory">
              <v-layout row wrap>

                <!-- start MAIN datastory content -->
                <v-flex class="xs12 md10 lg8 offset-md1 offset-lg2 mt-2">
                  <v-card flat>
                    <!-- start MAIN STORY -->
                    <v-card-text v-html="datastory.story.content">
                    </v-card-text>
                    <!--end MAIN STORY-->

                    <!-- start FIGURES -->
                    <v-card-text>
                    <v-carousel
                      light
                      pa-3
                      :hide-delimiters=false
                      interval=15000
                      :cycle=false
                    >
                      <v-carousel-item
                        v-for="(img, index) in sortImages(datastory.images)"
                        :key="index"
                      >
                        <v-img
                          height="35rem"
                          :src="require(`@/assets/img/datastories/${img.file}`)"
                          :alt="img.alt"
                          contain
                        >
                          <v-container fill-height fluid>
                            <v-layout fill-height class="lighten-4 carousel-captions">
                              <v-flex pt-2>
                                <span class="pa-2 white title blue--text text--darken-2" >{{ img.caption }}</span>
                              </v-flex>
                            </v-layout>
                          </v-container>
                        </v-img>
                      </v-carousel-item>
                    </v-carousel>
                    </v-card-text>
                    <!-- end FIGURES -->

                  </v-card>
                </v-flex>
                <!--end MAIN datastory content-->

                <!-- start METHODOLOGY -->
                <v-flex xs12 md10 lg8 offset-md1 offset-lg2 mt2>
                  <v-expansion-panel>
                    <v-expansion-panel-content>
                    <h4 slot="header" class="display-1">Methodology</h4>
                      <v-card flat>
                        <v-card-text>
                          <p class="subheading">For full methodological information, please <a href="static/handbook.pdf">download the KNOWMAK user handbook</a>.</p>
                          <div v-html="datastory.story.methodology"></div>
                        </v-card-text>
                      </v-card>
                    </v-expansion-panel-content>
                    <v-expansion-panel-content v-if="datastory.hasOwnProperty('resources')">
                    <h4 slot="header" class="display-1">Additional Resources</h4>
                      <v-card flat>
                        <v-card-text>
                          <ul>
                            <li v-for="resource in datastory.resources" :key="'resource_datastory_' + datastory.id + '_' + resource.id">
                              <a :href="'/static/resources/' + resource.file" target="_blank">Download {{resource.name}}</a>
                            </li>
                          </ul>
                        </v-card-text>
                      </v-card>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-slide-y-transition>
        </v-flex>
      </v-layout>

    </v-card>
  </div>
</template>

<script>
import { formatISODate } from '../util'

const imgBase = '/assets/img/datastories/'

export default {
  props: {
    datastory: Object,
    reversing: Boolean,
    archived: Boolean
  },
  data () {
    return {
      expandStory: false,
      btnLabel: 'Read more',
      expandLabel: 'Read more',
      collapseLabel: 'Show less',
      imgBase: imgBase
    }
  },
  methods: {
    formatPublicationDate (publicationDate) {
      return formatISODate(publicationDate)
    },
    toggleDataStory () {
      let offset = 0
      this.expandStory = !this.expandStory

      if (this.expandStory) {
        this.btnLabel = this.collapseLabel
        offset = -500
      } else {
        this.btnLabel = this.expandLabel
        offset = 0
      }

      this.$vuetify.goTo(this, {offset: offset, duration: 400, easing: 'easeInOutCubic'})
    },
    sortImages (images) {
      // only return images documenting the data story, not the teaser image
      let attachedImages = images.filter(function (i) {
        return i.teaser !== true
      })

      attachedImages.sort(function (a, b) {
        return a.id - b.id
      })
      return attachedImages
    },
    getTeaserImage (images) {
      let teaserImage = images.find(image => image.teaser === true)
      return teaserImage.file
    }
  },
  watch: {
    archived: {
      // the callback will be called immediately after the start of the observation
      immediate: true,
      handler (newVal, oldVal) {
        if (newVal === true) {
          this.expandStory = true
        }
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .carousel-captions {
    opacity: .85!important;
  }

  >>> .v-carousel__controls {
    background: rgba(0,0,0,.05);
  }

  >>> .v-carousel .theme--light.v-btn {
    color: rgba(0,0,0,.4);
  }
</style>



// WEBPACK FOOTER //
// src/components/DataStory.vue